import { useRouteError } from "react-router";
import { GeneralError, NotFoundError } from "@/pages/Errors";

export function ErrorBoundary() {
  const error = useRouteError();

  if ((error as any)?.status === 404) return <NotFoundError />;

  return <GeneralError />;
}
